import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { ResultsChartProps } from '../../types';

const ResultsChart: React.FC<ResultsChartProps> = ({
  answerCounts,
  correctOptionIndex,
}) => {
  // Convert answer counts to data format for recharts
  const data = answerCounts.map((count, index) => ({
    name: String.fromCharCode(65 + index), // A, B, C, D
    count: count,
    isCorrect: index === correctOptionIndex,
  }));
  
  // Autumn colors for the bars (matching answer options from CSS variables)
  const colors = [
    'hsl(25, 68%, 30%)',   // response-a: Marron Terre
    'hsl(21, 100%, 70%)',  // response-b: Orange Corail
    'hsl(74, 54%, 35%)',   // response-c: Vert Olive
    'hsl(4, 67%, 41%)',    // response-d: Rouge Brique Foncé
  ];
  const correctColor = '#4CAF50';  // Green for correct answers
  
  return (
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip 
            formatter={(value: number) => [`${value} responses`, 'Responses']}
            labelFormatter={(value: string) => `Option ${value}`}
          />
          <Bar dataKey="count" name="Responses">
            {data.map((entry, index) => (
              <Cell 
                key={`cell-${index}`}
                fill={entry.isCorrect ? correctColor : colors[index]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ResultsChart;